module.exports = __webpack_public_path__ + "img/COMP_ORANGE.f431db0c.svg";